import { loadingActionTypes } from "./loading.types";

export const selectLoading= state => state.loads.isLoading;

export const setLoading = () => ({
  type: loadingActionTypes.SET_LOADING
});

export const setNotLoading = () => ({
  type: loadingActionTypes.SET_NOT_LOADING
});